/**
 * Enterprise App Component
 * Hosted in src/app/ conforming to the Recommended Enterprise Architecture.
 */

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from './routes';

export function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
